module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": 'slide' + _vm.placement
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "aside",
    class: _vm.placement,
    style: ({
      width: _vm.width + 'px'
    })
  }, [_c('div', {
    staticClass: "aside-dialog"
  }, [_c('div', {
    staticClass: "aside-content"
  }, [_c('div', {
    staticClass: "aside-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.trigger_close
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "aside-title"
  }, [_vm._t("header", [_vm._v(_vm._s(_vm.header))])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "aside-body"
  }, [_vm._t("default")], 2)])])]) : _vm._e()])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c671724", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c671724!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Aside.vue
// module id = 86
// module chunks = 0